<template lang="pug">
form.box.box--filter.flex.items-center.bg-white.p-4.rounded.border.mb-4
    .result-filter__info.w-full.mobile-only
        .list.flex.items-center.justify-between.mb-3.pb-3.border-b
            strong Showing data
            div.btn-primary-o.btn-small(
                v-on:click="filterShow = !filterShow"
            ) Filter

        //- .list.flex.items-center.justify-between.mb-2
                span Limit data
                strong.monospace {{ record_size }}

        .list.flex.items-center.justify-between
            span Date
            strong.monospace {{ dateRange.startDate | date}} - {{ dateRange.endDate  | date}}

    .result-filter__action(
        v-bind:class="{'is-show' : filterShow}"
    )
        .mobile-only
            .header-filter.mb-4
                h2 Filter
                button(
                    v-on:click="filterShow = !filterShow"
                )
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        .flex.items-center
            //- .relative.mr-3
                select.field-style.block.appearance-none.w-full.bg-white.border.border-gray-500.text-gray-700.py-2.px-2.pr-8.rounded.leading-tight#filter-record-size(@change="sizeChange($event)" v-model="record_size")
                    option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                    <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>

            .relative.mr-3.field-date-time-picker
                date-range-picker(
                    v-if="dateRange.startDate && dateRange.endDate" 
                    ref="picker" 
                    v-model="dateRange" 
                    @update="pickerUpdate($event)" 
                    :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }" 
                    :date-format="dateFormat" 
                    opens="right" 
                    :ranges="default_ranges"
                    autoApply=true)
                    div(
                        slot="input" 
                        slot-scope="picker") 
                            | {{ picker.startDate | date}} - {{ picker.endDate  | date}}

                .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>

            .action-filter.flex.items-center(class="-mx-1")
                .w-full.px-1(class="md:w-1/2")
                    button.btn-primary-o(
                        v-if="isKey"
                        type="button"
                        @click="filter()"
                        v-on:click="filterShow = !filterShow"
                    ) Apply
                    button.btn-primary-o.btn-primary-o--disabled(
                        v-else type="button"
                        style="cursor: not-allowed;"
                        disabled="disabled"
                        v-on:click="filterShow = !filterShow"
                    ) Apply
                .w-full.px-1(class="md:w-1/2")
                    button.btn-default(
                        v-if="isKey"
                        type="button"
                        @click="reset()"
                        v-on:click="filterShow = !filterShow"
                    ) Reset
                    button.btn-default.btn-default--disabled(
                        v-else type="button"
                        style="cursor: not-allowed;"
                        disabled="disabled"
                        v-on:click="filterShow = !filterShow"
                    ) Reset
                .w-full.px-1(class="md:w-1/2")
                    template(v-if="retryShow")
                        button.btn-primary(
                            v-if="isKey"
                            type="button"
                            @click="filter()"
                            v-on:click="filterShow = !filterShow"
                        ) Retry
                        button.btn-primary.btn-primary--disabled(
                            v-else type="button"
                            style="cursor: not-allowed;"
                            disabled="disabled"
                            v-on:click="filterShow = !filterShow"
                        ) Retry
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { decrypt } from '@/util/crypto';

export default {
    name: 'ResultFilter',
    components: {
        DateRangePicker 
    },
    data: function () {
        return {
            size: [200,500,1000,2000,5000,9999],
            // curret_size: localStorage.getItem('record_size'),
            // // ----------------------------- vue date range picker
            // dateRange: {
            //     startDate: localStorage.getItem('from_date'),
            //     endDate: localStorage.getItem('end_date'),
            // },
            dateRange: {
                startDate: null,
                endDate: null,
            },
            default_ranges: {
                'Today': [moment().toDate(), moment().toDate()],
                'Yesterday': [moment().subtract(1, 'days').toDate(), moment().subtract(1, 'days').toDate()],
                // 'This month': [moment().startOf('month'), moment().endOf('month')],
                // 'This year': [moment().startOf('year'), moment().endOf('year')],
                'Last 7 days': [moment().subtract(6, 'days').toDate(), moment().toDate()],
                'Last week': [moment().subtract(1, 'week').startOf('week').toDate(), moment().subtract(1, 'week').endOf('week').toDate()],
                // 'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
            },
            filterShow: false,
            retryShow: false,
        };
    },
    computed: {
        ...mapState([
            // global
            'record_size',
            'from_date',
            'end_date',

            // per menu
            'from_date_recent_location',
            'end_date_recent_location',

            'from_date_application_usage',
            'end_date_application_usage',

            'from_date_history_location',
            'end_date_history_location',

            'from_date_history_browsing',
            'end_date_history_browsing',

            'from_date_device_history',
            'end_date_device_history',

            'from_date_tethered_devices',
            'end_date_tethered_devices',

            'from_date_possible_location',
            'end_date_possible_location',

            'from_date_aerial_log',
            'end_date_aerial_log',

            'from_date_signal_status',
            'end_date_signal_status',

            'load_data_status_overall_data_location',
            'load_data_status_overall_app_usage',
            'load_data_status_location',
            'load_data_status_browsing',
            'load_data_status_device_history',
            'load_data_status_tethered_device',
            'load_data_status_possible_location',
            'load_data_status_aerial_log',
            'load_data_status_signal_status',
        ]),
        // dateRange: {Top Aerial Log
        //             startDate: this.from_date,
        //             endDate: this.end_date,
        //         };
        //     },
        // },
        route_name() {
            return this.$route.name;
        },
        isKey() {
            return this.$route.params.key ? true : false;
        },
    },
    watch: {
        // curret_size() {},
        dateRange() {
            // this.dateChange();
        },
        route_name() {
            this.dateChange();
            this.retryChange();
        },
        isKey() {},

        from_date_recent_location() {
            this.dateChange();
        },
        end_date_recent_location() {
            this.dateChange();
        },

        from_date_application_usage() {
            this.dateChange();
        },
        end_date_application_usage() {
            this.dateChange();
        },

        from_date_history_location() {
            this.dateChange();
        },
        end_date_history_location() {
            this.dateChange();
        },

        from_date_history_browsing() {
            this.dateChange();
        },
        end_date_history_browsing() {
            this.dateChange();
        },

        from_date_device_history() {
            this.dateChange();
        },
        end_date_device_history() {
            this.dateChange();
        },

        from_date_tethered_devices() {
            this.dateChange();
        },
        end_date_tethered_devices() {
            this.dateChange();
        },

        from_date_possible_location() {
            this.dateChange();
        },
        end_date_possible_location() {
            this.dateChange();
        },

        from_date_aerial_log() {
            this.dateChange();
        },
        end_date_aerial_log() {
            this.dateChange();
        },

        from_date_signal_status() {
            this.dateChange();
        },
        end_date_signal_status() {
            this.dateChange();
        },
        
        load_data_status_overall_data_location(){
            this.retryChange();
        },
        load_data_status_overall_app_usage(){
            this.retryChange();
        },
        load_data_status_location(){
            this.retryChange();
        },
        load_data_status_browsing(){
            this.retryChange();
        },
        load_data_status_device_history(){
            this.retryChange();
        },
        load_data_status_tethered_device(){
            this.retryChange();
        },
        load_data_status_possible_location(){
            this.retryChange();
        },
        load_data_status_aerial_log(){
            this.retryChange();
        },
        load_data_status_signal_status(){
            this.retryChange();
        },
    },
    methods: {
        dateChange() {
            if(this.route_name == 'result-recent-location' || this.route_name == 'target-detail-recent-location') {
                this.dateRange.startDate = this.from_date_recent_location;
                this.dateRange.endDate = this.end_date_recent_location;

            } else if(this.route_name == 'result-application-usage' || this.route_name == 'target-detail-application-usage') {
                this.dateRange.startDate = this.from_date_application_usage;
                this.dateRange.endDate = this.end_date_application_usage;

            } else if(this.route_name == 'result-history-location' || this.route_name == 'target-detail-history-location') {
                this.dateRange.startDate = this.from_date_history_location;
                this.dateRange.endDate = this.end_date_history_location;

            } else if(this.route_name == 'result-history-browsing' || this.route_name == 'target-detail-history-browsing') {
                this.dateRange.startDate = this.from_date_history_browsing;
                this.dateRange.endDate = this.end_date_history_browsing;

            } else if(this.route_name == 'result-device-history' || this.route_name == 'target-detail-device-history') {
                this.dateRange.startDate = this.from_date_device_history;
                this.dateRange.endDate = this.end_date_device_history;

            } else if(this.route_name == 'result-tethered-devices' || this.route_name == 'target-detail-tethered-devices') {
                this.dateRange.startDate = this.from_date_tethered_devices;
                this.dateRange.endDate = this.end_date_tethered_devices;

            } else if(this.route_name == 'result-possible-location' || this.route_name == 'target-detail-possible-location') {
                this.dateRange.startDate = this.from_date_possible_location;
                this.dateRange.endDate = this.end_date_possible_location;

            } else if(this.route_name == 'result-aerial-log' || this.route_name == 'target-detail-aerial-log') {
                this.dateRange.startDate = this.from_date_aerial_log;
                this.dateRange.endDate = this.end_date_aerial_log;

            } else if(this.route_name == 'result-signal-status' || this.route_name == 'target-detail-signal-status') {
                this.dateRange.startDate = this.from_date_signal_status;
                this.dateRange.endDate = this.end_date_signal_status;
            }

        },
        retryChange() {
            // console.log('masuuuk retryChange')
            // console.log(this.load_data_status_aerial_log)
            // console.log(this.load_data_status_aerial_log.code)
            // console.log(this.load_data_status_aerial_log.code === 429)
            if(this.route_name == 'result-recent-location' || this.route_name == 'target-detail-recent-location') {
                // if(this.load_data_status_overall_data_location === false) {
                    // this.retryShow=true
                // }
            } else if(this.route_name == 'result-application-usage' || this.route_name == 'target-detail-application-usage') {
                if(this.load_data_status_overall_app_usage.code === 429) {
                    this.retryShow=true
                }
            } else if(this.route_name == 'result-history-location' || this.route_name == 'target-detail-history-location') {
                // if(this.load_data_status_overall_app_usage.code === 429) {
                //     this.retryShow=true
                // }
            } else if(this.route_name == 'result-history-browsing' || this.route_name == 'target-detail-history-browsing') {
                // if(this.load_data_status_overall_app_usage.code === 429) {
                //     this.retryShow=true
                // }
            } else if(this.route_name == 'result-device-history' || this.route_name == 'target-detail-device-history') {
                if(this.load_data_status_device_history.code === 429) {
                    this.retryShow=true
                }
            } else if(this.route_name == 'result-tethered-devices' || this.route_name == 'target-detail-tethered-devices') {
                if(this.load_data_status_tethered_device.code === 429) {
                    this.retryShow=true
                }
            } else if(this.route_name == 'result-possible-location' || this.route_name == 'target-detail-possible-location') {
                if(this.load_data_status_possible_location.code === 429) {
                    this.retryShow=true
                }
            } else if(this.route_name == 'result-aerial-log' || this.route_name == 'target-detail-aerial-log') {
                if(this.load_data_status_aerial_log.code === 429) {
                    this.retryShow=true
                }
            } else if(this.route_name == 'result-signal-status' || this.route_name == 'target-detail-signal-status') {
                if(this.load_data_status_signal_status.code === 429) {
                    this.retryShow=true
                }
            }
        },
        sizeChange(e) {
            // this.$store.state.record_size = parseInt(e.target.value);
            this.$store.commit('setRecordSize', parseInt(e.target.value));
            // localStorage.removeItem('record_size');
            // localStorage.setItem('record_size', parseInt(e.target.value));
        },
        /* eslint-disable no-unused-vars */
        dateFormat (classes, date) {
            if (!classes.disabled) {
                // console.log('on dateFormat')
                // console.log(moment(date.getTime())._d)

                // classes.disabled = date.getTime() > new Date();
                classes.disabled = moment(date.getTime()).subtract({ hours: 12})._d > new Date();
            }
            return classes;
        },
        async pickerUpdate(e) {
            // console.log('========= DateRangePicker on update')
            // console.log(e)
            console.log('pickerUpdate route_name')
            console.log(this.route_name)

            let ranges = moment(e.endDate.getTime()).diff(moment(e.startDate.getTime()), 'days') + 1;


            if (ranges > 7 && !['result-tethered-devices','target-detail-tethered-devices', 'result-device-history', 'target-detail-device-history'].includes(this.route_name)) {
                const default_date = this.$store.getters.getDefaultDate();

                await this.$store.commit('setFromDatePerMenu', [this.route_name, default_date.from_date]);
                await this.$store.commit('setEndDatePerMenu', [this.route_name, default_date.end_date]);

                await this.dateChange();

                this.$swal.fire({
                    icon: 'error',
                    title: 'Date range is not more than 7 days!',
                    text: 'Your date range is ' + ranges + ' days.',
                    // confirmButtonText: 'Yes!',
                    // confirmButtonColor: '#DD6B55',
                    // showCancelButton: true,
                    // allowOutsideClick: false,
                })

                // return;
            } else {
                let startDate = moment(e.startDate.getTime()).format('YYYY-MM-DD');
                let endDate = moment(e.endDate.getTime()).format('YYYY-MM-DD');

                // with persisted state 
                // this.$store.commit('setFromDate', startDate);
                // this.$store.commit('setEndDate', endDate);

                // per menu
                this.$store.commit('setFromDatePerMenu', [this.route_name, startDate]);
                this.$store.commit('setEndDatePerMenu', [this.route_name, endDate]);
            }
        },
        reset() {
            // if (!confirm("Are you sure you want to reset?")) {
            //     // console.log('no')
            //     return;
            // }

            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset?',
                // text: 'Role : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');

                if (result.isConfirmed) {
                    const default_date = this.$store.getters.getDefaultDate();
                    const record_size = this.$store.getters.getDefaultRecordSize;

                    // console.log(record_size)

                    // localStorage.removeItem('record_size');
                    // localStorage.removeItem('from_date');
                    // localStorage.removeItem('end_date');

                    // localStorage.setItem('record_size', record_size);
                    // localStorage.setItem('from_date', default_date.from_date);
                    // localStorage.setItem('end_date', default_date.end_date);

                    // this.curret_size = record_size;
                    // document.querySelector('#filter-record-size [value="' + this.curret_size + '"]').selected = true;

                    // this.dateRange = {
                    //     startDate: default_date.from_date,
                    //     endDate: default_date.end_date,
                    // };

                    // with persisted state
                    this.$store.commit('setRecordSize', record_size);
                    // this.$store.commit('setFromDate', default_date.from_date);
                    // this.$store.commit('setEndDate', default_date.end_date);

                    this.$store.commit('setFromDatePerMenu', [this.route_name, default_date.from_date]);
                    this.$store.commit('setEndDatePerMenu', [this.route_name, default_date.end_date]);

                    this.filter();
                }
            });
        },
        filter() {
            this.retryShow = false
            // console.log('=========================== in ResultFiler.vue -> filter()')
            // console.log(this.decryptData());

            // var record_size = document.getElementById('filter-record-size');
            // var date_range = document.getElementById('filter-date-range');
            // console.log(record_size.value)
            // console.log(date_range.value)


            // this.$router.push({ name: 'result-recent-location', params: { key: encrypt(key + '&&' + type) }  });

            var decrypt_data = this.decryptData();

            // console.log(decrypt_data)
            // console.log(this.$route.matched[0].name)


            // if (this.$route.matched[0].path === '/result') {
            if ((this.$route.matched[0].name === 'PageResult' || this.$route.matched[0].name === 'PageTargetDetail') && decrypt_data !== null) {

                // old, get all data from api
                // this.$store.dispatch('getResultData', [decrypt_data.key, decrypt_data.type]);
                // console.log('resultFilter method filter')

                // [key, type, getApi='all', fromSidebar=false, detail_target=false, from_filter_result=true]
                // this.$store.dispatch('getResultData', [decrypt_data.key, decrypt_data.type, this.$route.matched[1].name]);
                this.$store.dispatch('getResultData', [decrypt_data.key, decrypt_data.type, this.$route.matched[1].name, false, false, true]);
                
                // only filter in current page
                // this.$store.dispatch('getResultData', ['', decrypt_data.key, decrypt_data.type]);

                // console.log(this.$route.matched[1].name)


                // this.$router.push({ name: this.$route.matched[1].name, params: { key: encrypt(decrypt_data.key + '&&' + decrypt_data.type) } });
            }

        },
        decryptData() {
            let data = null;

            if (this.$route.params.key) {
                let decrypt_data = decrypt(this.$route.params.key);
                decrypt_data = decrypt_data.split('&&');
                // console.log(decrypt_data);

                var key = decrypt_data[0];
                var type = decrypt_data[1];

                data = { key: key, type: type };
            }
            return data;
        },
    },
    filters: {
        date: function (date) {
            return moment(date).format('YYYY-MM-DD');
        }
    },
    mounted() {
        // console.log('=========================== in ResultFiler.vue')
        // document.querySelector('#filter-record-size [value="' + this.curret_size + '"]').selected = true;
        // console.log('curret_size : ' + this.curret_size);
        
        // console.log(this.route_name);
        this.dateChange();
        this.retryChange(); 

        // console.log(this.datepicker_ranges.Today[0].getTime)
        // console.log(new Date().setHours(0, 0, 0, 0).getTime())
        // console.log(moment().getTime())
    }
}
</script>

<style lang="sass">
.daterangepicker
    .ranges
        float: left

.field-date-time-picker
    .reportrange-text
        width: 100%
        box-shadow: none
        line-height: 40px
        padding: 0px 32px 0px 12px
        color: #3d3d3d
        border-color: #a0aec0
        background: #ffffff
        height: 40px
        -webkit-appearance: none !important
        -moz-appearance: none !important
        appearance: none !important
</style>
